<template>
  <div
    class="rounded-xl flex-col gap-5 items-start lg:items-center lg:flex-row bg-white py-4 px-5 flex justify-between"
  >
    <div>
      <h2 class="text-dark-100 text-xl font-semibold">{{ $t(title) }}</h2>
      <slot name="subtitle" />
    </div>
    <div class="w-full lg:w-auto flex items-center flex-col md:flex-row gap-4">
      <slot name="action" />
      <CButton
        variant="info"
        :disabled="cancelBtn.disabled"
        :loading="cancelBtn.loading"
        :text="$t(cancelBtn.text)"
        :class="cancelBtn.width"
        class="w-full md:w-[120px]"
        type="button"
        @click="$emit('on-cancel')"
      />
      <CButton
        variant="primary"
        :disabled="acceptBtn.disabled"
        :loading="acceptBtn.loading"
        :text="$t(acceptBtn.text)"
        :class="acceptBtn.width"
        icon-position="left"
        :icon="isEdit ? 'icon-tick-square !text-sm leading-[24px]' : 'icon-add'"
        class="w-full md:w-[120px]"
        type="button"
        @click="$emit('on-create')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import CButton from "@/components/Common/CButton.vue";

interface Props {
  title: string;
  cancelBtn?: {
    text: string;
    disabled?: boolean;
    loading?: boolean;
    width?: string;
  };
  acceptBtn?: {
    text: string;
    disabled?: boolean;
    loading?: boolean;
    width?: string;
  };
  isEdit?: boolean;
}
withDefaults(defineProps<Props>(), {
  cancelBtn: () => {
    return {
      text: "cancel",
      disabled: false,
      loading: false,
      width: "w-[120px]",
    };
  },
  acceptBtn: () => {
    return {
      text: "create",
      disabled: false,
      loading: false,
      width: "w-[120px]",
    };
  },
});

defineEmits<{
  (e: "on-cancel"): void;
  (e: "on-create"): void;
}>();
</script>
